<template>
  <el-card class="logistics-card">
    <el-form :model="logisticsForm" label-width="60">
      <el-form-item  :label="$t('mobile.transferOut.sku')">
        <el-input disabled style="width:200px" v-model="formInline.sku" :placeholder="$t('mobile.transferOut.sku')" ></el-input>
      </el-form-item>
      <el-form-item  :label="$t('mobile.transferOut.quantity') ">
        <el-input autofocus style="width:200px" type="number" v-model="formInline.quantity" :placeholder="$t('mobile.transferOut.quantity')" ></el-input>
      </el-form-item>
      <el-form-item class="warehouse-item" :label="$t('mobile.transferOut.warehouse') ">
        <el-select
            v-model="formInline.receiveWarehouseId"
            style="width:200px"
            filterable
            reserve-keyword
            :placeholder="$t('mobile.transferOut.warehouses')"
            remote-show-suffix
            :loading="loading"
            class="warehouse-select"
            @change="handleChange"
            :readonly="true"
            :inputmode="'none'"
        >
          <el-option
              v-for="item in stockList"
              :key="item.warehousefCode"
              :label="item.warehouseName"
              :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item  :label="$t('mobile.transferOut.skus')">
        <el-input style="width:200px" v-model="formInline.newSku" :placeholder="$t('mobile.transferOut.new_sku')" ></el-input>
      </el-form-item>
      <el-form-item  :label="$t('mobile.transferOut.SN')">
        <el-input style="width:200px" type="textarea"
                  @change="handleChangeText"
                  :autosize="{ minRows: 2, maxRows: 8}"
                  v-model="formInline.snNumber" :placeholder="$t('mobile.transferOut.SNs')" ></el-input>
      </el-form-item>
      <el-form-item  :label="$t('mobile.transferOut.remark')">
        <el-input style="width:200px" type="textarea" v-model="formInline.remark" :placeholder="$t('mobile.transferOut.remarks')" ></el-input>
      </el-form-item>
      <!-- 图片上传区域 -->
      <div class="form-section" >
        <h3 class="section-title">
          <el-icon><Picture /></el-icon>
          {{$t("mobile.inStore.upload")}}
        </h3>

        <!-- 外包装图片 -->
        <div class="upload-section">
          <div class="upload-header">
            <h4 class="upload-title">{{$t("mobile.inStore.outer")}}</h4>
            <span class="upload-desc">{{$t("mobile.inStore.outer_prompt")}}</span>
          </div>
          <el-upload
              :on-success="getUploadUrl"
              :before-upload="handleBeforeUpload"
              v-model:file-list="formInline.outerImageOrign"
              :action="uploadUrl"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              class="custom-upload"
          >
            <div class="upload-placeholder">
              <el-icon class="upload-icon"><Plus /></el-icon>
              <span class="upload-text">{{$t("mobile.inStore.upload")}}</span>
            </div>
          </el-upload>
        </div>

        <!-- 设备通电图片 -->
        <div class="upload-section">
          <div class="upload-header">
            <h4 class="upload-title">{{$t("mobile.inStore.equipment")}}</h4>
            <span class="upload-desc">{{$t("mobile.inStore.equipment_prompt")}}</span>
          </div>
          <el-upload
              :on-success="getUploadUrls"
              :before-upload="handleBeforeUpload"
              v-model:file-list="formInline.equipmentImageOrign"
              :action="uploadUrl"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemoves"
              class="custom-upload"
          >
            <div class="upload-placeholder">
              <el-icon class="upload-icon"><Plus /></el-icon>
              <span class="upload-text">{{$t("mobile.inStore.upload")}}</span>
            </div>
          </el-upload>
        </div>
      </div>


      <div class="flex flex-row-center">
        <el-button  type="primary"  @click="transferOut">{{$t('mobile.transferOut.transfer')}}</el-button>
      </div>
    </el-form>
  </el-card>
</template>
<script>
import {ElButton,ElForm,ElFormItem,ElSelect,ElOption,ElInput,ElMessage,ElUpload,ElIcon} from "element-plus";
import {getFullUrl, getLocalStockList} from "../../../public/js";
import {transferOut} from "@/utils/api";
import {uploadUrl} from "@/utils/requset";
export default {
  name: "transferOut",
  components:{
    ElButton,ElForm,ElFormItem,ElSelect,ElOption,ElInput,ElUpload,ElIcon
  },
  data(){
    return{
      mark:false,
      uploadUrl:"",
      stockList:[],
      formInline:{
        sku:'',
        quantity:0,
        receiveWarehouseId:"",
        newSku:'',
        snNumber:"",
        outerImage:[],
        outerImageOrign:[],
        equipmentImageOrign:[],
        equipmentImage:[],
        remark:""
      }
    }
  },
  beforeMount() {
    this.uploadUrl = uploadUrl
    this.formInline = {...this.formInline,...this.$route.query}
    this.formInline.newSku =this.formInline.sku
    this.getLocalStockList()
  },
  methods:{
    async getLocalStockList(){
      await getLocalStockList().then(res => {
        this.stockList = res.filter(item=>{
          return item.warehouseName.includes("美国售后仓") && item.warehouseName!="804-美国售后仓-不良品仓"
        })
        console.log(this.stockList)
      })
    },
    handleChange(val) {
      let stock = this.stockList.find((item) => {
        return item.id === val; // 返回2
      });
      if(stock.warehouseName=="827-美国售后仓-二手良品仓"){
        this.formInline.newSku =  this.formInline.sku+"1"
        this.mark = true
      }else {
        this.formInline.newSku =  this.formInline.sku
        this.mark = false
      }
    },
    handleChangeText(){
      const arr = this.formInline.snNumber.split(/\r?\n/).filter(item => item.trim() !== '');

      // 使用Set去重并转回数组
      const uniqueArr = [...new Set(arr)]
      this.formInline.snNumber =uniqueArr.join('\n')
    },
    transferOut(){
      if(!this.formInline.sku){
        ElMessage.warning(this.$t('mobile.transferOut.error'))
        return
      }
      if(this.formInline.quantity<=0){
        ElMessage.warning(this.$t('mobile.transferOut.quantity_err'))
        return
      }
      if(!this.formInline.receiveWarehouseId){
        ElMessage.warning(this.$t('mobile.transferOut.warehouse_err'))
        return
      }
      if(!this.formInline.newSku){
        ElMessage.warning(this.$t('mobile.transferOut.new_sku'))
        return
      }
      if(!this.formInline.snNumber){
        ElMessage.warning(this.$t('mobile.transferOut.SNs'))
        return
      }else {
        const arr = this.formInline.snNumber.split(/\r?\n/).filter(item => item.trim() !== '');
        if(arr.length != this.formInline.quantity){
          ElMessage.warning(this.$t('mobile.transferOut.sn_quan_err'))
          return
        }
      }
      // if(this.reMarks){
      //   if(this.formInline.outerImage.length==0){
      //     ElMessage.warning(this.$t("mobile.inStore.equipment_prompt"))
      //     return
      //   }
      //   if(this.formInline.equipmentImage.length==0){
      //     ElMessage.warning(this.$t("mobile.inStore.equipment_prompt"))
      //     return
      //   }
      // }
      transferOut(this.formInline).then(res=>{
        console.log(res)
        ElMessage.success(this.$t('saveSuccess') )
        this.$router.push('/transferList');
      }).catch(err=>{
        console.log(err)
        this.$message.error('保存失败：' + err.Msg);
      })
    },
    getUploadUrl(response){
      let url = getFullUrl(response.location)
      this.formInline.outerImageOrign[this.formInline.outerImageOrign.length-1].url = url
      this.formInline.outerImage.push(url)
    },
    getUploadUrls(response){
      let url = getFullUrl(response.location)
      this.formInline.equipmentImageOrign[this.formInline.equipmentImageOrign.length-1].url = url
      this.formInline.equipmentImage.push(getFullUrl(response.location))
    },
    handleBeforeUpload(file){
      const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJPGOrPNG) {
        ElMessage.error(this.$t("mobile.returnList.uploadPrompt"));
        return false; // 不上传该文件
      } else if (file.size / 1024 / 1024 > 8) {
        ElMessage.error(this.$t("mobile.returnList.uploadSize"))
        return false
      }
    },
    handlePictureCardPreview(uploadFile){
      this.dialogImageUrl = uploadFile.url
      this.dialogVisible = true
      return
    },
    handleRemove(uploadFile, uploadFiles){
      console.log(uploadFile, uploadFiles)
      let fullUrl = getFullUrl(uploadFile.response.location)
      this.formInline.outerImage = this.formInline.outerImage.filter(item=>{
        return  item!=fullUrl
      })
    },
    handleRemoves(uploadFile, uploadFiles){
      console.log(uploadFile, uploadFiles)
      let fullUrl = getFullUrl(uploadFile.response.location)
      this.formInline.equipmentImage = this.formInline.equipmentImage.filter(item=>{
        return  item!=fullUrl
      })
    },
  }
}
</script>
<style scoped>
.logistics-card {
  margin: 10px;
  padding: 20px;
  border-radius: 10px;
}

.form-section {
  padding: 10px 5%;
}

.form-section:last-of-type {
  border-bottom: none;
}
</style>